import script from "./VButton.vue?vue&type=script&lang=ts"
export * from "./VButton.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__